import { useState } from 'react'

const NAV_LINKS = [
  {
    label: 'Market Place',
    href: process.env.REACT_APP_MARKETPLACE_URL || 'https://marketplace.businessbay.io/',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l1-5h16l1 5"/>
        <path d="M3 9h18v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/>
        <path d="M9 9v3a3 3 0 006 0V9"/>
      </svg>
    ),
  },
  {
    label: 'E-Commerce Store',
    href: process.env.REACT_APP_ECOMMERCE_URL || 'https://ecommerce.businessbay.tech/',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 001.95-1.57L23 6H6"/>
      </svg>
    ),
  },
  {
    label: 'Real Estate',
    href: process.env.REACT_APP_REAL_ESTATE_URL || 'https://businessbay.io/real-estate-website-builder/',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/>
        <path d="M9 21V12h6v9"/>
      </svg>
    ),
  },
  {
    label: 'Influencer Program',
    href: process.env.REACT_APP_INFLUENCER_URL || 'https://influencer.businessbay.tech/',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    ),
  },
  {
    label: 'Food Mart',
    href: process.env.REACT_APP_RESTAURANT_URL || 'https://restaurant.businessbay.io/',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8h1a4 4 0 010 8h-1"/><path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z"/>
        <line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/>
      </svg>
    ),
  },
  // {
  //   label: 'NFC Smart Card',
  //   href: process.env.REACT_APP_NFC_CARD_URL || 'https://businessbay.io/smart-nfc-card',
  //   icon: (
  //     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
  //       <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
  //       <line x1="1" y1="10" x2="23" y2="10"/>
  //     </svg>
  //   ),
  // },
  {
    label: 'Cab Service',
    href: process.env.REACT_APP_CAB_URL || 'https://cab.businessbay.io/',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 17H3a2 2 0 01-2-2V9a2 2 0 012-2h2"/>
        <rect x="9" y="5" width="6" height="14" rx="1"/>
        <path d="M15 17h2a2 2 0 002-2V9a2 2 0 00-2-2h-2"/>
        <circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/>
        <path d="M9 5l-2 2M15 5l2 2"/>
      </svg>
    ),
  },
  {
    label: 'No-Code App',
    href: process.env.REACT_APP_NOCODE_APP_URL || 'https://businessbay.io/no-code-app-builder/',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
        <line x1="8" y1="21" x2="16" y2="21"/>
        <line x1="12" y1="17" x2="12" y2="21"/>
        <polyline points="9 10 12 7 15 10"/>
        <line x1="12" y1="7" x2="12" y2="13"/>
      </svg>
    ),
  },
  {
    label: 'AI Chatbot',
    href: process.env.REACT_APP_AI_CHATBOT_URL || 'https://businessbay.io/ai-chatbot/',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="14" rx="2" ry="2"/>
        <circle cx="8.5" cy="10" r="1.5"/>
        <circle cx="15.5" cy="10" r="1.5"/>
        <path d="M8 21l2-4h4l2 4"/>
      </svg>
    ),
  },
]

const POLICY_LINKS = [
  { label: 'Blogs',              href: 'https://businessbay.io/blogs' },
  { label: 'Privacy policy',     href: 'https://businessbay.io/privacy-policy' },
  { label: 'Refund policy',      href: 'https://businessbay.io/refund-policy' },
  { label: 'Terms & Conditions', href: 'https://businessbay.io/terms-and-conditions' },
  // { label: 'Market Place',       href: `https://marketplace.businessbay.io/`}
]

function NavLink({ href, label, icon }) {
  const [hovered, setHovered] = useState(false)
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '12px 20px',
        fontSize: '14px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        textDecoration: 'none',
        color: hovered ? '#2B5CF6' : '#94A3B8',
        borderBottom: `2px solid ${hovered ? '#2B5CF6' : 'transparent'}`,
        transition: 'all 0.2s',
        // fontFamily: "Inter", -apple-sy/stem, BlinkMacSystemFont, "Segoe UI", sans-serif
        fontFamily:`Inter `
      }}
    >
      <span style={{ color: hovered ? '#2B5CF6' : '#94A3B8', display: 'flex' }}>{icon}</span>
      {label}
    </a>
  )
}

function PolicyLink({ href, label }) {
  const [hovered, setHovered] = useState(false)
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontSize: '14px',
        color: hovered ? '#2B5CF6' : '#94A3B8',
        textDecoration: 'none',
        transition: 'color 0.2s',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {label}
    </a>
  )
}

export default function Footerlink() {
  return (
    <footer style={{ background: '#ffffff', borderTop: '1px solid #E2E8F0' }}>
      {/* Product links strip */}
      <div style={{ maxWidth: '1400px', margin: '0 auto', overflowX: 'auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 'max-content', margin: '0 auto', borderBottom: '1px solid #E2E8F0' }}>
          {NAV_LINKS.map((link) => (
            <NavLink key={link.label} href={link.href} label={link.label} icon={link.icon} />
          ))}
        </div>
      </div>

      {/* Copyright + policy links */}
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px 20px' }}>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          // borderTop: '1px solid #E2E8F0',
          paddingTop: '16px',
        fontFamily:`Inter `,
        

        }}>
          <p style={{ fontSize: '14px', color: '#6d7d93', margin: 0 , 
          fontFamily:`Inter  "Segoe UI", sans-serif`}}>
            Copyrights © 2026. BusinessBay.io. All right reserved.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
            {POLICY_LINKS.map((l) => (
              <PolicyLink key={l.label} href={l.href} label={l.label} />
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
